<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle | translate}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-8 m-0" fusePerfectScrollbar>

        <form autocomplete="off" [formGroup]="requestForm">

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Request Type' | translate }}</mat-label>
                    <mat-select formControlName="type" required #requestType
                        (selectionChange)='checkTypeChange(requestType)'>
                        <mat-option *ngFor="let requestType of requestTypes" [value]="requestType">
                            {{requestType.name}}
                        </mat-option>
                        <mat-option *ngIf="requestTypes && !requestTypes.length">No types defined</mat-option>
                    </mat-select>
                    <mat-error *ngIf="checkServerError('type')"> {{checkServerError('type')}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" *ngIf="selectedType === 'Data change'">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Comment' | translate }}</mat-label>
                    <input name="comment" formControlName="comment" matInput>
                </mat-form-field>
            </div>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <!-- <button mat-button class="save-button text-uppercase" (click)="updateRequest(requestForm)" [disabled]="requestForm.invalid || requestForm.pristine"
            aria-label="SAVE" *ngIf="action === 'edit'">
            {{'Save' | translate }}
        </button> -->

        <button mat-button class="save-button text-uppercase" (click)="createRequest(requestForm)"
            [disabled]="requestForm.invalid" aria-label="SAVE" *ngIf="action === 'new'">
            {{'Add' | translate }}
        </button>

    </div>
</div>